import React, { Component } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import ReactGA from 'react-ga';
import { signOut } from "../../actions/authActions";
import { isMobile,buttonsContentManage } from '../../utils/util';
import "./MobileNavMenuItems.css";
import Responsive from 'react-responsive';

import Api from '../../utils/api';

class MobileNavMenuItems extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visitedRecommendations: false
    };
  }
  componentDidMount() {
      const userId = localStorage.getItem("user_id");
      if(!userId){
        return false
      }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.active){
      document.body.style.overflow = "hidden";
    }else{
      document.body.style.overflow = "auto";
    }

    var mobilenavmenuObj = document.getElementsByClassName('mobile-nav-menu-items-container__item-list')[0]

    var promobannerObjHeight = document.getElementById('promo-banner-container-second').offsetHeight;
    mobilenavmenuObj.style.top=(promobannerObjHeight-10)+'px';
  }
  gotoOnboarding() {
    window.fbq('track', 'Lead');
    if (process.env.REACT_APP_ENV === 'prod') {
        ReactGA.event({
            category: 'TakeQuiz',
            action: 'Click',
            label: 'MainCTA',
            value: 1
        });
        this.gtag_report_conversion_get_started();
    }
  }
  gtag_report_conversion_get_started(url) {
    let callback = function () {
    if (typeof(url) !== 'undefined') {
      window.location = url;
        }
    };
    if(window.gtag)
    window.gtag('event', 'conversion', {
          'send_to': 'AW-782420739/tzYpCN279owBEIOWi_UC',
          'event_callback': callback
    });
    return false;
  }

  funUserLogOut(){
    this.props.signOut();
  }

  funUserGotoSignin(){
    this.props.history.push('/signin');
  }


  render() {
    const isAuthenticated =
      this.props.isAuthenticated || !!localStorage.getItem("auth_token");

    return (
      <div
        // style={
        //   localStorage.getItem("user_has_hair_profile") &&
        //   !localStorage.getItem("user_has_sk") && { top: "8.75rem" }
        // }
        className={
          this.props.active
            ? "mobile-nav-menu-list"
            : "mobile-nav-menu-list hide"
        }
      >
        <div className="mobile-nav-menu-items-container">
          {isAuthenticated ?  (
            localStorage.getItem("gateFeePaid") == 'true' ?
            (
            <ul className="mobile-nav-menu-items-container__item-list" style={this.props.active ?{display:'block'}:{display:'none'}}>
                <li>
                    <a
                    href={
                        !window.location.pathname.includes("/hair/")
                        ? "/survey-result"
                        : "/hair/profile"
                    }
                    >
                    {!window.location.pathname.includes("/hair/")
                        ? "My Skin Profile"
                        : "My Hair Profile"}
                    </a>
                </li>

                <li>
                    <a href={ buttonsContentManage() }>My Recommendations</a>
                </li>

                <li>
                    <a target={ isMobile(navigator.userAgent) ? "_self" : "_blank" } href="https://shop.helloava.co/?utm_source=webapp&utm_medium=nav&utm_campaign=shop_ha">Shop</a>
                </li>

                <li className="menu-solid">
                <a href="/account">Account Settings</a>
                </li>

                <li className="menu-solid-bootom">
                    <a href="/orders">Order History</a>
                </li>

                <li>
                    <a href="/Blog">Ava Academy Blog</a>
                </li>

                <li>
                    <a href="/our-story">Our Story</a>
                </li>

                <li className="thank-you-area">
                    <Responsive maxWidth={ 769 }>
                        <div className="free-skincare-area" onClick={()=>{  this.props.history.push("/referral") }}>
                            <div className="free-skincare-area-text">
                                <div className="paragraphBold1 navy">Earn $20 in free skincare</div>
                                <div className="paragraphRegular5 navy">Send friends $20. <br/> Get $20 yourself. That’s what best friends do!</div>
                            </div>
                            <img className="skincare" src="/images/thankYou/free-mobile.png"></img>
                        </div>
                    </Responsive>
                </li>
            </ul>

          ):(
            <ul className="mobile-nav-menu-items-container__item-list" style={this.props.active ?{display:'block'}:{display:'none'}}>
                <li>
                    <a target={ isMobile(navigator.userAgent) ? "_self" : "_blank" } href="https://shop.helloava.co/?utm_source=webapp&utm_medium=nav&utm_campaign=shop_ha">Shop</a>
                </li>
                <li>
                    <a href="/Blog">Ava Academy Blog</a>
                </li>
                <li>
                <a href="/our-story">Our Story</a>
                </li>
                <li>
                    <a href="/referral">Get $20</a>
                </li>
                <li>
                    <NavLink to={ buttonsContentManage() }>
                        <button className="section-button">
                            { buttonsContentManage('buttonText') }
                        </button>
                    </NavLink>
                </li>
            </ul>
          )
          ) : (
            <ul className="mobile-nav-menu-items-container__item-list" style={this.props.active ?{display:'block'}:{display:'none'}}>
              
              <li>
                <a target={ isMobile(navigator.userAgent) ? "_self" : "_blank" } href="https://shop.helloava.co/?utm_source=webapp&utm_medium=nav&utm_campaign=shop_ha">Shop</a>
              </li>

              {/* <li>
                <a className="hair-menu-item" href="/hair/landing">
                  My Hair
                </a>
              </li> */}
              <li>
                <a href="/Blog">Ava Academy</a>
              </li>
              <li>
                <a href="/our-story">Our Story</a>
              </li>
              <li>
                {/* <a onClick={this.props.onOpenModal}>Get $20</a> */}
                <a href="/referral">Get $20</a>

              </li>
              <li>
                <a href="/gift">Gift</a>
              </li>
              <li>
                <NavLink to={ buttonsContentManage() }>
                    <button className="section-button">
                        { buttonsContentManage('buttonText') }
                    </button>
                </NavLink>
                </li>
            </ul>
          )}
          

          <div className="transiMaxhidden" style={this.props.active ?{display:'block'}:{display:'none'}}>
            {isAuthenticated ? 
            
            // (
            //   <div className="mobile-menu-container__bottom-section">
            //     <ul className="mobile-menu-container__bottom-skin-hair-blocks">
            //       <li
            //         className={
            //           window.location.pathname.includes("/survey-result") ||
            //           window.location.pathname === "/recommendations" ||
            //           window.location.pathname.includes("/account") ||
            //           window.location.pathname.includes("/orders") ||
            //           window.location.pathname.includes("reviewed") ||
            //           window.location.pathname.includes("wishlist")
            //             ? "mobile-menu-container__bottom-skin-hair-block mobile-menu-container__bottom-skin-hair-block__active mobile-menu-container__bottom-skin-hair-block__skin"
            //             : "mobile-menu-container__bottom-skin-hair-block mobile-menu-container__bottom-skin-hair-block__skin"
            //         }
            //       >
            //         <a
            //           onClick={e => {
            //             if (!localStorage.getItem("user_has_skin_profile")) {
            //               e.preventDefault();
            //               this.props.renderHairPopup(false);
            //             }
            //           }}
            //           href={
            //             localStorage.getItem("user_has_skin_profile")
            //               ? "/survey-result"
            //               : "/onboarding"
            //           }
            //         >
            //           My Skin
            //         </a>
            //       </li>
            //     </ul>
            //   </div>
            // ) 
            null
            : 
              null
            // (
            //   <div className="mobile-menu-container__bottom-section" style={localStorage.getItem("auth_token") ?{}:{display:'none'} }>
            //     <NavLink
            //       to={
            //         window.location.pathname.includes("/hair/")
            //           ? "/hair/onboarding"
            //           : "/onboarding"
            //       }
            //     >
            //       <button>
            //         {window.location.pathname.includes("/hair/")
            //           ? "START HAIR QUIZ"
            //           : "START SKIN QUIZ"}
            //       </button>
            //     </NavLink>
            //   </div>
            // )
            
          }

          </div>

          <div className="bottom-logIn-button" style={this.props.active ?{}:{maxHeight:0}}>
            {
              localStorage.getItem("auth_token")?<div onClick={()=> this.funUserLogOut()} style={{color: '#272d67'}}>Log out</div>
              :
              <div onClick={()=>this.funUserGotoSignin()} style={{color: '#272d67'}}>Log in</div>
            }
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { helloava } = state;
  const { isAuthenticated } = helloava.auth;
  return { isAuthenticated };
}

function mapDispatchToProps(dispatch) {
  return {
    signOut: () => dispatch(signOut())
  };
}

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(MobileNavMenuItems));



// WEBPACK FOOTER //
// ./src/components/header/MobileNavMenuItems.js